<script setup lang="ts">
import type { FeedActivity } from '@/types/customer/ActivitiesFeed'
import ActivityCardBase from './ActivityCardBase.vue'

const { t, locale } = useI18n()

const props = defineProps<{
  activity: FeedActivity
  showConnector?: boolean
}>()

const getLocalizedText = (
  value: FeedActivity['title'] | FeedActivity['description'] | string | null | undefined
): string => {
  if (!value) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'object') {
    return value[locale.value as keyof typeof value] || value.en || ''
  }
  return ''
}

const description = computed(() => {
  const descText = getLocalizedText(props.activity.description)
  if (descText) return descText

  let rewardName = props.activity.data?.reward_name
  if (props.activity.data?.points) {
    rewardName = `${props.activity.data?.points} ${t('pages.customer.customerDetailPage.blocks.points.points')}`
  }
  const storeName = props.activity.data?.store_name || props.activity.data?.store || ''
  const hasWon = Boolean(rewardName)
  const translationKey = hasWon
    ? 'pages.customer.customerDetailPage.blocks.activity.contestGameParticipation.text.win'
    : 'pages.customer.customerDetailPage.blocks.activity.contestGameParticipation.text.lose'

  return t(translationKey, { reward: rewardName || '', store: storeName })
})

const title = computed(() => {
  return getLocalizedText(props.activity.title) || ''
})

const iconColor = computed(() => {
  return 'bg-red-400'
})
</script>

<template>
  <ActivityCardBase
    :icon="activity.icon || 'HeroPlayIconSolid'"
    :icon-color="iconColor"
    :occurred-at="activity.occurred_at"
    :show-connector="showConnector"
  >
    <template #title>
      <p class="text-sm font-medium text-foreground">{{ title }}</p>
    </template>
    <template #description>
      <p class="mt-1 text-sm text-muted-foreground">{{ description }}</p>
    </template>
  </ActivityCardBase>
</template>
